import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

// --- PREMIUM CUSTOM ICONS (No external library needed) ---
const Icons = {
  Hospital: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22v-7l-2-2"></path>
      <path d="M17 22v-8.82a2 2 0 0 0-2.17-2l-5 1.6-5-1.6"></path>
      <path d="M2 22v-8c0-1.1.9-2 2-2h1"></path>
      <path d="M22 22v-8c0-1.1-.9-2-2-2h-1"></path>
      <rect x="7" y="2" width="10" height="4" rx="2"></rect>
      <path d="M7 6v12"></path>
      <path d="M17 6v12"></path>
    </svg>
  ),
  Doctor: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"></path>
      <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4"></path>
      <circle cx="20" cy="10" r="2"></circle>
    </svg>
  ),
  Lab: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 18h8"></path>
      <path d="M3 22h18"></path>
      <path d="M14 22a7 7 0 1 0 0-14h-1"></path>
      <path d="M9 14h2"></path>
      <path d="M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z"></path>
      <path d="M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3"></path>
    </svg>
  ),
  Pharmacy: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path>
      <path d="m8.5 8.5 7 7"></path>
    </svg>
  )
};

const Services = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const services = [
    {
      title: "Hospital Management",
      icon: <Icons.Hospital />,
      description: "End-to-end digitization of clinical workflows and administrative tasks.",
      features: ["Patient EMR/EHR", "Appointment Scheduling", "Billing & Insurance", "Staff Management"]
    },
    {
      title: "Doctor Portals",
      icon: <Icons.Doctor />,
      description: "Secure, role-based access for professionals to manage patient care seamlessly.",
      features: ["Prescription Management", "Lab Results", "Secure Messaging", "Treatment Planning"]
    },
    {
      title: "Lab & Diagnostics",
      icon: <Icons.Lab />,
      description: "High-precision digital solutions for sample tracking and automated reporting.",
      features: ["Sample Tracking", "Result Automation", "Equipment Integration", "Compliance Reporting"]
    },
    {
      title: "Pharmacy Hub",
      icon: <Icons.Pharmacy />,
      description: "Comprehensive inventory and prescription systems for zero-error fulfillment.",
      features: ["Inventory Tracking", "Drug Interaction Check", "Claim Processing", "Customer CRM"]
    }
  ];

  return (
    <div className="services-premium">
      {/* Advanced Hero Section */}
      <section className="services-hero">
        <div className="container">
          <span className="badge-glow">Specialized Ecosystem</span>
          <h1>Advanced HealthTech Solutions</h1>
          <p>Precision-engineered software designed to transform modern healthcare operations.</p>
        </div>
      </section>

      {/* Modern Services Grid */}
      <section className="services-grid-section">
        <div className="container">
          <div className="premium-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card-glass">
                <div className="card-icon-header">
                  <span className="service-icon">{service.icon}</span>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="feature-tags">
                  {service.features.map((feature, i) => (
                    <span key={i} className="tag">{feature}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Flow */}
      <section className="process-premium">
        <div className="container">
          <h2 className="section-title">The Integration Flow</h2>
          <div className="process-timeline">
            {[
              { step: "01", title: "Discovery", desc: "Workflow analysis and gap identification." },
              { step: "02", title: "Design", desc: "Custom medical UI/UX tailored to your facility." },
              { step: "03", title: "Build", desc: "Secure, scalable, and HIPAA-compliant coding." },
              { step: "04", title: "Go-Live", desc: "Rigorous testing and environment deployment." }
            ].map((item, i) => (
              <div key={i} className="timeline-item">
                <div className="timeline-number">{item.step}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Impactful CTA */}
      <section className="premium-cta-section">
        <div className="container">
          <div className="cta-gradient-box">
            <h2>Ready to digitize your facility?</h2>
            <p>Join the ecosystem of hospitals using Smart QR Health for a better patient experience.</p>
            <Link to="/contact" className="btn-primary" onClick={scrollToTop}>Start Your Transformation</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;